import * as Yup from "yup";
// import dayjs from "dayjs";

// export const getValidationVerifySchema = ({ maxQty = '', enableTrackBatch = false }) => {

export const validationSchema = Yup.object({
    docItemId: Yup
        .string()
        .required("Required"),
    rackId: Yup
        .string()
        .required("Required"),
    slotId: Yup
        .string()
        .required("Required"),
    itemCode: Yup
        .string()
        .required("Required"),
    // expiryDate: Yup
    //     .date("Invalid")
    //     .required("Required")
    //     .typeError("Invalid"),
    customBatchNo: Yup
        .string()
        .required("Required"),
    inventoryBatchId: Yup
        .string()
        .required("Required"),
    inventoryQty: Yup.lazy((val) => {

        let maxQty = val?.maxQty? val.maxQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid")
        })

    }),
    verifyQty: Yup.lazy((val) => {

        let maxQty = val?.maxQty? val.maxQty : 0

        let valueSchema;

        // if(maxQty){
        //     verifyOutQty = Yup.object({
        //         verifyOutQty: Yup
        //             .number()
        //             .typeError("Only number")
        //             // .positive("Qty must more than zero")
        //             .max(maxQty, `Max only ${maxQty}`)
        //             .required("Required"),
        //     })

        // }else{
        //     verifyOutQty = Yup.object({
        //         verifyOutQty: Yup
        //             .number()
        //             .typeError("Only number")
        //             .positive("Must more than zero")
        //             .required("Required"),
        //     })
        // }

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid")
        })
            

    })
})

export const initialValues = {
    docItemId: "",
    itemName: "",
    rackId: "",
    rackDisplay: "",
    slotId: "",
    slotDisplay: "",
    // verifyOutQty: "",
    itemCode: "",
    customBatchNo: "",
    expiryDate: "", // dayjs(),
    inventoryBatchId: "",
    verifyQty: {
        value: "0",
        maxQty: "0"
    },
    inventoryQty: {
        value: "0",
        maxQty: "0"
    }
}
